"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeatLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_spinners_1 = require("react-spinners");
function BeatLoader(props) {
    return jsx_runtime_1.jsx(react_spinners_1.BeatLoader, Object.assign({}, props), void 0);
}
exports.BeatLoader = BeatLoader;
//# sourceMappingURL=index.js.map